import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import AppShell from '@/components/AppShell'
import ErrorBoundary from '@/components/ErrorBoundary'
import { SCREENS } from '@/configs/screens'
import { ROUTES } from '@/constants'
import { ProjectProvider } from '@/contexts/ProjectProvider'
import Deliveries from '@/pages/Deliveries'
import NotFound from '@/pages/NotFound'
import Placeholder from '@/pages/Placeholder'
import SiteSetup from '@/pages/SiteSetup'

import './styles/App.css'

// Entra ID SSO wraps this component from the outside — <AuthProvider> in
// main.tsx (@blattnercompany/react-auth) redirects unauthenticated visits to
// Entra, so nothing here is auth-aware and no route is a login screen.
// See CLAUDE.md § Auth.

function App() {
  return (
    <BrowserRouter>
      {/* Outer boundary catches crashes in the provider and shell chrome;
          the inner one keeps the shell alive when a page throws. */}
      <ErrorBoundary>
        <ProjectProvider>
          <AppShell>
            <ErrorBoundary>
              <Routes>
                {/* Today owned the root until #126800; Deliveries is the start
                    of the daily loop. replace keeps / out of history. */}
                <Route
                  path={ROUTES.HOME}
                  element={<Navigate to={ROUTES.DELIVERIES} replace />}
                />
                {/* Screens without a real page yet (Receiving) fall back to
                    Placeholder — swap the element here when one lands. */}
                {SCREENS.map((screen) => (
                  <Route
                    key={screen.route}
                    path={screen.route}
                    element={
                      screen.route === ROUTES.DELIVERIES ? (
                        <Deliveries />
                      ) : screen.route === ROUTES.SETUP ? (
                        <SiteSetup />
                      ) : (
                        <Placeholder
                          title={screen.label}
                          storyId={screen.storyId}
                        />
                      )
                    }
                  />
                ))}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </ErrorBoundary>
          </AppShell>
        </ProjectProvider>
      </ErrorBoundary>
    </BrowserRouter>
  )
}

export default App
